import { render, staticRenderFns } from "./scanner.vue?vue&type=template&id=b5a2e21c&"
import script from "./scanner.vue?vue&type=script&lang=js&"
export * from "./scanner.vue?vue&type=script&lang=js&"
import style0 from "./scanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "scanner.vue"
export default component.exports